import { render, staticRenderFns } from "./UserUpdatePassowrd.vue?vue&type=template&id=57033f62&"
import script from "./UserUpdatePassowrd.vue?vue&type=script&lang=js&"
export * from "./UserUpdatePassowrd.vue?vue&type=script&lang=js&"
import style0 from "./UserUpdatePassowrd.vue?vue&type=style&index=0&id=57033f62&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports